import { render, staticRenderFns } from "./BlockPaymentSystemAdd.vue?vue&type=template&id=6e98c298&"
import script from "./BlockPaymentSystemAdd.vue?vue&type=script&lang=ts&"
export * from "./BlockPaymentSystemAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports